import { create } from "zustand";
import api from "@/lib/api";

export const useAuth = create((set, get) => ({
  user: null,
  branch: null,
  permissions: [],
  // D30 -- effective per-user RBAC matrix (role defaults + D26 overrides).
  // Populated by /auth/me. Consumers use `useMatrix(key)` from
  // `@/hooks/usePermission` to gate UI. Route handlers still enforce
  // server-side; this is purely for hide/show and never trusted for
  // authorization decisions.
  matrix: {},
  matrixOverrides: { granted: [], revoked: [] },
  loading: true,
  error: null,

  hydrate: async () => {
    set({ loading: true });
    try {
      const { data } = await api.get("/auth/me");
      set({
        user: data.user, branch: data.branch,
        permissions: data.permissions,
        matrix: data.matrix || {},
        matrixOverrides: data.matrix_overrides || { granted: [], revoked: [] },
        loading: false,
      });
    } catch (_e) {
      set({ user: null, branch: null, permissions: [],
             matrix: {}, matrixOverrides: { granted: [], revoked: [] },
             loading: false });
    }
  },

  login: async (email, password) => {
    set({ error: null });
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("sharda_token", data.token);
      await get().hydrate();
      return { ok: true };
    } catch (e) {
      set({ error: e?.response?.data?.detail || "Login failed" });
      return { ok: false, error: e?.response?.data?.detail || "Login failed" };
    }
  },

  logout: async () => {
    try { await api.post("/auth/logout"); } catch (_e) { /* ignore */ }
    localStorage.removeItem("sharda_token");
    // Phase 8B (bugfix): clear any active module-visibility preview overlay.
    try {
      const { useModuleVisibility } = await import("./moduleVisibility");
      useModuleVisibility.getState().reset();
    } catch (_e) { /* ignore -- import cycle guard */ }
    set({ user: null, branch: null, permissions: [],
           matrix: {}, matrixOverrides: { granted: [], revoked: [] } });
  },

  setLanguage: async (lng) => {
    try { await api.post("/auth/preferences/language", { language: lng }); } catch (_e) { /* ignore */ }
    const u = get().user;
    if (u) set({ user: { ...u, language: lng } });
  },
}));
